import { render, staticRenderFns } from "./SelectSensorsForTrainingModal.vue?vue&type=template&id=8f3b5574&scoped=true&"
import script from "./SelectSensorsForTrainingModal.vue?vue&type=script&lang=js&"
export * from "./SelectSensorsForTrainingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3b5574",
  null
  
)

export default component.exports